export default __webpack_public_path__ + "static/media/code-connect-challenge-with-medal.d5afa60e.png";